import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { ProfileConfirmModalComponent } from '../../../../dashboard/loggedin-content/profile/profile-confirm-modal/profile-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { UserDetailsService } from './../../../../../_services/profile-settings/user-details.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import {
  FormBase,
  FormBaseControlService,
  AlertService,
  GTagService,
} from '@mapfre-design-library/src/public_api';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { ChangePhoneService } from './../../../../../_services/profile-settings/change-phone.service';
import { ProfileConfirmModalService } from '../../../../../_services/profile-settings/profile-confirm-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ProfileConfirmModalComponent, MapfreAlertComponent, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-change-phone',
  templateUrl: './change-phone.component.html',
})
export class ChangePhoneComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  phoneAccountForm: FormGroup;
  phoneNumber: string;
  confirmModal: boolean;
  route: string;

  constructor(
    private alertService: AlertService,
    private changePhoneService: ChangePhoneService,
    private ipt: FormBaseControlService,
    public router: Router,
    private profileConfirmModalService: ProfileConfirmModalService,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private gTagService: GTagService,
    private translate: TranslateService
  ) {}

  onCheckDirty() {
    this.profileConfirmModalService.onCheckDirty(this.phoneAccountForm);
    this.profileConfirmModalService.$checkDirty.subscribe((value) => {
      this.confirmModal = value;
    });

    if (this.confirmModal === false) {
      this.router.navigate(['/profile']);
    }
  }

  onSubmitPhoneDetails() {
    this.phoneNumber =
      this.phoneAccountForm.controls.accountPhone.value.replace(/[^0-9]/g, '');
    this.changePhoneService
      .addUpdatePhone(
        this.storageService.getUserFromStorage(),
        this.phoneNumber
      )
      .subscribe(
        () => {
          this.gTagService.triggerFormLink('phoneAccountForm', 'true', '');
          this.userDetailsService.getUserDetailsByEmail().subscribe();
          this.routePhone();
        },
        (error) => {
          if (
            error.status === 400 ||
            error.status === 401 ||
            error.status === 403 ||
            error.status === 404 ||
            error.status === 408
          ) {
            this.routePhone();
          } else {
            this.gTagService.triggerFormLink(
              'phoneAccountForm',
              'false',
              this.translate.instant('PHONE_NUMBER_UPDATE_ERROR')
            );
            this.alertService.error('There was updating your phone number');
          }
        }
      );
  }

  routePhone() {
    if (this.router.url === '/profile/edit-phone') {
      this.alertService.success('PHONE_UPDATED_SUCCESSFULLY', true);
    } else {
      this.alertService.success('PHONE_ADDED_SUCCESSFULLY', true);
    }
    this.router.navigate(['/profile']);
  }

  ngOnInit() {
    this.route = this.router.url;
    this.phoneNumber = this.inputs[0].value;
    this.phoneAccountForm = this.ipt.toFormGroup(this.inputs);
  }
}
